/* eslint-disable  */
import { debounce } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import { format } from "timeago.js";
import { Search } from "lucide-react";
import Loader from "../../Components/Loader";
import { dataActionCreators } from "../../services/Actions";
import RenderLoanPage from "../RenderLoanPage";
import { ToastContainer, toast } from "react-toastify";

function LoanStatus() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { GetAppliedLoans, ResetDataResponse } = bindActionCreators(dataActionCreators, dispatch);
  const [checkSouthLoan, setCheckSouthLoan] = useState(false);
  const [checkNorthLoan, setCheckNorthLoan] = useState(false);
  const [search, setSearch] = useState(null);
  const [limit, setLimit] = useState(30);
  const data = useSelector((state) => state?.data);
  const status = "all";

  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = limit;

  const { appliedLoans, paginate, isLoading, response } = data;

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setPageCount(Number(paginate?.total));
  }, [itemOffset, itemsPerPage, appliedLoans]);

  const handlePageClick = (event) => {
    GetAppliedLoans(true, event.selected + 1, limit, status);
    const newOffset = (event.selected * itemsPerPage) % paginate?.total;
    setItemOffset(newOffset);
  };

  const onSearchTextChange = debounce((e) => {
    if (e?.target?.value) {
      setSearch(e?.target?.value ?? null);
      GetAppliedLoans(true, 1, limit, status, `${e?.target?.value ? "&search=" + e?.target?.value : ""}`);
    } else {
      setSearch(null);
      GetAppliedLoans(true, 1, limit, status);
    }
  }, 800);

  const Northern = checkNorthLoan && "Northern";
  const Southern = checkSouthLoan && "Southern";

  let sectorSeleted = "";
  if (checkNorthLoan) sectorSeleted = "North";
  else if (checkSouthLoan) sectorSeleted = "South";
  else sectorSeleted = "No";

  // Status color mapping
  const getStatusStyle = (statusVal) => {
    switch (statusVal) {
      case "submitted":
        return "bg-blue-50 text-blue-700 border-blue-100";
      case "booked":
        return "bg-green-50 text-green-700 border-green-100";
      case "authorized":
        return "bg-teal-50 text-teal-700 border-teal-100";
      case "initiated":
        return "bg-amber-50 text-amber-700 border-amber-100";
      case "paid":
        return "bg-emerald-50 text-emerald-700 border-emerald-100";
      case "rejected":
        return "bg-red-50 text-red-700 border-red-100";
      default:
        return "bg-slate-50 text-slate-700 border-slate-100";
    }
  };

  // --- Activity trail -------------------------------------------------------
  // Each loan carries trail objects (submitted/booked/authorized/initiated/paid/
  // rejected). Every object holds a Unix-ms `date` (Date.now()) and an `officer`
  // name. We turn those raw timestamps into a readable, chronological timeline.
  const TRAIL_STAGES = [
    { key: "submitted", label: "Submitted", dot: "bg-blue-500", text: "text-blue-700" },
    { key: "booked", label: "Booked", dot: "bg-green-500", text: "text-green-700" },
    { key: "authorized", label: "Authorized", dot: "bg-teal-500", text: "text-teal-700" },
    { key: "initiated", label: "Initiated", dot: "bg-amber-500", text: "text-amber-700" },
    { key: "paid", label: "Paid", dot: "bg-emerald-500", text: "text-emerald-700" },
    { key: "rejected", label: "Rejected", dot: "bg-red-500", text: "text-red-700" },
  ];

  // Schema declares these as arrays but the service writes plain objects —
  // accept either shape.
  const getStageNode = (value) => (Array.isArray(value) ? value[0] : value);

  // Older records sometimes stored a raw Mongo ObjectId (or nothing) in place of
  // the officer's name. Treat those as "unknown" so we never print an id or "—".
  const cleanOfficer = (value) => {
    if (!value) return null;
    const name = String(value).trim();
    if (!name || name === "—" || /^[0-9a-f]{24}$/i.test(name)) return null;
    return name;
  };

  // The DB stores Unix milliseconds. Coerce numeric strings before parsing so
  // moment treats them as timestamps, and only keep genuinely valid dates.
  const parseTrailDate = (value) => {
    if (value === null || value === undefined || value === "") return null;
    const m = isNaN(Number(value)) ? moment(value) : moment(Number(value));
    return m.isValid() ? m : null;
  };

  const buildTrail = (loan) =>
    TRAIL_STAGES.map((stage) => {
      const node = getStageNode(loan?.[stage.key]);
      const date = parseTrailDate(node?.date);
      if (!date) return null; // missing/legacy/{status:false} stages drop out
      // `by` is null when we have no real name — the row then hides the "by" line.
      const by =
        stage.key === "submitted"
          ? `${loan?.user?.name || "Member"} (member)`
          : cleanOfficer(node?.officer);
      // Rejected carries a reason and an "edit requested" flag for the member.
      const message = stage.key === "rejected" ? node?.message : null;
      const editRequested =
        stage.key === "rejected" && (node?.editFormChecked || node?.resubmit);
      return { ...stage, date, by, message, editRequested };
    })
      .filter(Boolean)
      .sort((a, b) => a.date.valueOf() - b.date.valueOf());

  useEffect(() => {
    GetAppliedLoans(true, 1, limit, status);
    setCheckNorthLoan(false);
    setCheckSouthLoan(false);
  }, []);

  useEffect(() => {
    GetAppliedLoans(true, 1, limit, status);
  }, [limit]);

  useEffect(() => {
    if (Northern && Southern) {
      GetAppliedLoans(true, 1, limit, status);
    } else if (Northern) {
      GetAppliedLoans(true, 1, limit, status, `${Northern ? "&filter=" + "Northern" : ""}`);
    } else if (Southern) {
      GetAppliedLoans(true, 1, limit, status, `${Southern ? "&filter=" + "Southern" : ""}`);
    } else {
      GetAppliedLoans(true, 1, limit, status);
    }
  }, [Southern, Northern]);

  useEffect(() => {
    GetAppliedLoans(true, 1, limit, status, `${Northern ? "&filter=" + "Northern" : ""}`);
  }, [Northern]);

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => ResetDataResponse(), 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => ResetDataResponse(), 1500);
    }
  }, [response?.state]);

  return (
    <RenderLoanPage title="Loan Status">

      {/* SEARCH & FILTER BAR */}
      <div className="flex flex-col sm:flex-row gap-4 mb-6">
        <div className="flex-1">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
            <input
              type="search"
              placeholder="Search by Staff ID.."
              className="w-full pl-10 pr-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent shadow-sm"
              onChange={onSearchTextChange}
            />
          </div>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={() => { setCheckSouthLoan(!checkSouthLoan); setCheckNorthLoan(false); }}
            className={`px-4 py-2 rounded-xl text-sm font-semibold transition-all ${checkSouthLoan ? "bg-indigo-600 text-white shadow-md" : "bg-white border border-slate-200 text-slate-600 hover:bg-slate-50"}`}
          >
            South
          </button>
          <button
            onClick={() => { setCheckNorthLoan(!checkNorthLoan); setCheckSouthLoan(false); }}
            className={`px-4 py-2 rounded-xl text-sm font-semibold transition-all ${checkNorthLoan ? "bg-indigo-600 text-white shadow-md" : "bg-white border border-slate-200 text-slate-600 hover:bg-slate-50"}`}
          >
            North
          </button>
          <select
            className="px-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
            onChange={(e) => setLimit(e.target.value)}
          >
            <option value={30}>30 per page</option>
            <option value={50}>50 per page</option>
            <option value={100}>100 per page</option>
            <option value={200}>200 per page</option>
            <option value={500}>500 per page</option>
          </select>
        </div>
      </div>

      {/* TABLE */}
      <section className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
        {/* <div className="p-6 border-b border-slate-50">
          <h2 className="text-xs font-bold text-slate-800">Loan Status</h2>
        </div> */}

        {isLoading ? (
          <div className="p-6">
            <Loader />
          </div>
        ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="dark:bg-gray-800 bg-slate-50">
                <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Member Info</th>
                <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Loan Amount</th>
                <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Activity Trail</th>
                <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Status</th>
                {/* <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Sector</th> */}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {appliedLoans?.length > 0 ? (
                appliedLoans.map((loan) => {
                  const trail = buildTrail(loan);
                  return (
                    <tr key={loan?._id} className="hover:bg-slate-50/80 transition-colors">
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-3">
                          <img className="w-10 h-10 rounded-full border border-slate-200 object-cover shadow-sm" src={loan?.user?.profile_image || "/images/dev/avatar1.png"} alt="Profile" />
                          <div>
                            <p className="text-sm font-bold text-slate-800 leading-tight">{loan?.user?.name}</p>
                            <p className="text-xs font-medium text-slate-500">{loan?.staff_id}</p>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-emerald-50 text-emerald-700 border border-emerald-100">&#8373;{loan?.loanAmount}</span>
                        <p className="text-xs text-slate-400 mt-1">MD: {loan?.monthlyDeduction}</p>
                      </td>
                      <td className="px-6 py-4 align-top min-w-[260px]">
                        {trail.length > 0 ? (
                          <ol className="relative">
                            {trail.map((t, idx) => (
                              <li key={t.key} className="relative pl-6 pb-4 last:pb-0">
                                {/* connector line to the next stage */}
                                {idx !== trail.length - 1 && (
                                  <span className="absolute left-[5px] top-2 -bottom-1 w-px bg-slate-200" aria-hidden />
                                )}
                                {/* stage dot */}
                                <span className={`absolute left-0 top-1 w-[11px] h-[11px] rounded-full ring-2 ring-white dark:ring-gray-900 ${t.dot}`} aria-hidden />
                                <div className="flex flex-wrap items-baseline gap-x-2 leading-tight">
                                  <span className={`text-xs font-bold ${t.text} dark:brightness-150`}>{t.label}</span>
                                  <span className="text-[11px] text-slate-400 dark:text-slate-500 whitespace-nowrap">{t.date.format("MMM DD, YYYY • h:mm A")}</span>
                                </div>
                                {t.by && (
                                <p className="text-xs text-slate-500 dark:text-slate-400 leading-tight mt-0.5">by {t.by}</p>
                              )}
                                {t.message && (
                                  <div className="mt-1.5 px-2.5 py-1.5 bg-red-50 dark:bg-red-950/50 border dark:bg-slate-600 border-red-100 dark:border-red-900 rounded-lg">
                                    <p className="text-[11px] text-white dark:text-stone-200  leading-snug">{t.message}</p>
                                    {t.editRequested && (
                                      <span className="inline-flex items-center gap-1 mt-1 text-[12px] font-semibold text-white dark:text-stone-200">
                                        &#9998; Edit requested
                                      </span>
                                    )}
                                  </div>
                                )}
                              </li>
                            ))}
                          </ol>
                        ) : (
                          <span className="text-xs text-slate-400 italic">No activity yet</span>
                        )}
                      </td>
                      <td className="px-6 py-4">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${getStatusStyle(loan?.status)}`}>
                          {loan?.status}
                        </span>
                      </td>
                      {/* <td className="px-6 py-4">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${loan?.sector === "Northern" ? "bg-red-50 text-red-700 border-red-100" : "bg-blue-50 text-blue-700 border-blue-100"}`}>{loan?.sector}</span>
                    </td> */}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="4" className="px-6 py-12 text-center text-slate-400 italic">No {sectorSeleted !== "No" ? sectorSeleted : ""} loans status at the moment.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        )}

        {appliedLoans?.length > 0 && (
          <div className="border-t border-slate-100">
            <ReactPaginate
              breakLabel="..." nextLabel=">" onPageChange={handlePageClick} pageRangeDisplayed={5} pageCount={pageCount} previousLabel="<" renderOnZeroPageCount={null}
              containerClassName="flex items-center justify-center gap-1 py-4"
              pageLinkClassName="px-3 py-1.5 rounded-lg text-sm font-medium text-slate-600 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
              previousLinkClassName="px-3 py-1.5 rounded-lg text-sm font-medium text-slate-600 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
              nextLinkClassName="px-3 py-1.5 rounded-lg text-sm font-medium text-slate-600 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
              activeLinkClassName="!bg-indigo-600 !text-white shadow-sm"
            />
          </div>
        )}
      </section>
      <ToastContainer autoClose={3000} />
    </RenderLoanPage>
  );
}

export default LoanStatus;
